import request from '@/http/request'
// 商户看板数据汇总
export function getDashboardSum () {
  return request.request({
    url: '/api/dashboard/v2/sum',
    method: 'GET'
  })
}

// /api/dashboard/v2/hourlyOrderCount/{payType}
// 获取指定支付类型的订单数小时统计 payType: 0-Pay-in 1-Payout
export const getHourlyOrderCount = (payType) => {
  return request.request({
    url: `/api/dashboard/v2/hourlyOrderCount/${payType}`,
    method: 'GET'
  })
}

// 获取七日平台交易金额趋势
export const getSevenDaysTrend = (payType) => {
  return request.request({
    url: `/api/dashboard/v2/sevendayorderamountsum/${payType}`,
    method: 'GET'
  })
}

// /api/dashboard/v2/hourlyorderamountsum/{payType}
// 获取指定支付类型的订单支付金额小时统计 payType: 0-Pay-in 1-Payout
export const getHourlyOrderAmountSum = (payType) => {
  return request.request({
    url: `/api/dashboard/v2/hourlyorderamountsum/${payType}`,
    method: 'GET'
  })
}

// 获取每小时订单成功率汇总 payType: 0-Pay-in 1-Payout
// /api/dashboard/v2/hourlyordersuccessrate/{payType}
export const getHourlyOrderSuccessRate = (payType) => {
  return request.request({
    url: `/api/dashboard/v2/hourlyordersuccessrate/${payType}`,
    method: 'GET'
  })
}
